import BreadCrumb from "components/common/BreadCrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import AttendanceGrid from "./AttendanceGrid";
import { getDocumentTitle } from "utils/helpers";
import { useProfile } from "features/Authentication/hooks/useProfile";
import { RoleCode } from "features/RolesAndPermissions/constants/role.constants";

const EmployeeAttendance = () => {
  document.title = getDocumentTitle("Employee Attendance");
  const { highestRole, user } = useProfile();
  const isProjectEngineer = highestRole?.code === RoleCode.PROJECT_ENGINEER;
  const lockedEmployeeId = isProjectEngineer ? (user?.employee?.id ?? null) : null;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Employee Attendance" pageTitle="HR Management" />
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Attendance Sheet</h5>
            <p className="text-muted small mb-0 mt-1">
              Click any day cell to mark or update attendance for that employee.
            </p>
          </CardHeader>
          <CardBody>
            <AttendanceGrid lockedEmployeeId={lockedEmployeeId} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default EmployeeAttendance;
